import { Injectable, Pipe, APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';

class ConfigLoader {
}
class ConfigStaticLoader {
    constructor(providedSettings) {
        this.providedSettings = providedSettings;
    }
    loadSettings() {
        return Promise.resolve(this.providedSettings);
    }
}

class ConfigService {
    constructor(loader) {
        this.loader = loader;
    }
    init() {
        return this.loader.loadSettings().then((res) => (this.settings = res));
    }
    getSettings(key, defaultValue) {
        if (!key || (Array.isArray(key) && !key[0])) {
            return this.settings;
        }
        const paths = !Array.isArray(key) ? key.split('.') : key;
        let result = paths.reduce((acc, current) => acc && acc[current], this.settings);
        if (result === undefined) {
            result = defaultValue;
            if (result === undefined) {
                throw new Error(`No setting found with the specified key [${paths.join('/')}]!`);
            }
        }
        return result;
    }
}
ConfigService.decorators = [
    { type: Injectable }
];
ConfigService.ctorParameters = () => [
    { type: ConfigLoader }
];

class ConfigPipe {
    constructor(config) {
        this.config = config;
    }
    transform(value) {
        return this.config.getSettings(value);
    }
}
ConfigPipe.decorators = [
    { type: Injectable },
    { type: Pipe, args: [{
                name: 'config'
            },] }
];
ConfigPipe.ctorParameters = () => [
    { type: ConfigService }
];

function configFactory() {
    return new ConfigStaticLoader();
}
function initializerFactory(config) {
    const res = () => config.init();
    return res;
}
class ConfigModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('ConfigModule already loaded; import in root module only.');
        }
    }
    static forRoot(configuredProvider = {
        provide: ConfigLoader,
        useFactory: configFactory
    }) {
        return {
            ngModule: ConfigModule,
            providers: [
                configuredProvider,
                ConfigService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializerFactory,
                    deps: [ConfigService],
                    multi: true
                }
            ]
        };
    }
}
ConfigModule.decorators = [
    { type: NgModule, args: [{
                declarations: [ConfigPipe],
                exports: [ConfigPipe]
            },] }
];
ConfigModule.ctorParameters = () => [
    { type: ConfigModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

export { configFactory, initializerFactory, ConfigModule, ConfigLoader, ConfigStaticLoader, ConfigPipe, ConfigService };

//# sourceMappingURL=ngx-config-core.js.map